// src/utils/fetchPatch.js
// Monkey-patch global fetch with token refresh logic

const BASE_URL = process.env.REACT_APP_API_URL || "";

function toUrlString(input) {
  if (typeof input === "string") return input;
  try {
    return input?.url?.toString?.() || String(input);
  } catch {
    return String(input);
  }
}

function isAbsolute(u) {
  return /^https?:\/\//i.test(u);
}

async function customFetch(input, init = {}) {
  const originalUrl = toUrlString(input);
  const isApi = originalUrl.startsWith("/api");
  const url =
    !isAbsolute(originalUrl) && isApi && BASE_URL
      ? `${BASE_URL}${originalUrl}`
      : originalUrl;

  const token = localStorage.getItem("token");
  const headers = {
    ...(init.headers || {}),
    ...(isApi && token ? { Authorization: `Bearer ${token}` } : {}),
  };

  let response = await window._originalFetch(url, { ...init, headers });

  // If unauthorized on an API call, try refresh (avoid infinite loop)
  const isRefreshEndpoint = url.startsWith(`${BASE_URL}/api/auth/refresh`);
  if (isApi && response.status === 401 && !isRefreshEndpoint) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      handleLogout();
      return response;
    }

    const refreshRes = await window._originalFetch(
      `${BASE_URL}/api/auth/refresh`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken }),
      },
    );

    if (refreshRes.ok) {
      const data = await refreshRes.json();
      const newAccessToken = data.accessToken || data.access_token;
      const newRefreshToken = data.refreshToken || data.refresh_token;

      if (newAccessToken) {
        localStorage.setItem("token", newAccessToken);
        if (newRefreshToken)
          localStorage.setItem("refreshToken", newRefreshToken);

        const retryHeaders = {
          ...(init.headers || {}),
          Authorization: `Bearer ${newAccessToken}`,
        };
        response = await window._originalFetch(url, {
          ...init,
          headers: retryHeaders,
        });
      } else {
        handleLogout();
      }
    } else {
      handleLogout();
    }
  }

  return response;
}

function handleLogout() {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  window.location.href = "/login";
}

// Save original fetch in case we need it
if (!window._originalFetch) {
  window._originalFetch = window.fetch.bind(window);
  window.fetch = customFetch;
}
